import { CommonModule } from '@angular/common';
import { CUSTOM_ELEMENTS_SCHEMA, NgModule } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { MatButtonModule } from '@angular/material/button';
import { MatCardModule } from '@angular/material/card';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatIconModule } from '@angular/material/icon';
import { MatInputModule } from '@angular/material/input';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';
import { BrowserModule } from '@angular/platform-browser';
import { IMaskModule } from 'angular-imask';
import { HalfBackgroundComponent, InvalidFieldComponent } from 'src/app/shared/components';
import { LogoFacilityComponent } from 'src/app/shared/components/logo-facility/logo.component';
import { ScrollTopDirective } from 'src/app/shared/directives/scroll-top.directive';
import { SearchInitModule } from 'src/app/shared/modules/search/search.module';
import { SearchAwbComponent } from './search-awb.component';

@NgModule({
    imports: [
        CommonModule,
        BrowserModule,
        ReactiveFormsModule,
        FormsModule,
        LogoFacilityComponent,
        InvalidFieldComponent,
        MatCardModule,
        MatIconModule,
        MatInputModule,
        MatButtonModule,
        SearchInitModule,
        ScrollTopDirective,
        HalfBackgroundComponent,
        IMaskModule,
        MatFormFieldModule,
        MatProgressSpinnerModule,
    ],
    declarations: [SearchAwbComponent],
    schemas: [CUSTOM_ELEMENTS_SCHEMA],
})
export class SearchModule {}
